import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
  z-index: 10000;
  
  left: 0;
  bottom: 0;
  position: fixed;

  width: 100%;
  height: auto; 

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  max-height: 75px;
  padding: 16px;

  gap: 0.25rem;
  display: flex;
  align-items: flex-end;
  justify-content: space-evenly;

  background-color: transparent;
  backdrop-filter: blur(24px);

  @media (max-width: 350px) {
   padding: 16px 0;
  }
`;

export const ButtonLink = styled.div`
  width: auto;
  height: auto;
  padding: 0 0.5rem;

  /* gap: 0.25rem; */
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  border-radius: 16px;
  /* background-color: ${props => (props.active ? theme.colors.green.Verde_AgroReceita : theme.colors.white.Branco )}; */

  &:nth-of-type(3){
      gap: 0rem;

      border-radius: 8px;

      >a{
        width: 50px;
        height: 50px;
        margin-bottom: 2px;

        border-radius: 50%;
        border: 1px solid transparent;
        --button-bg: ${theme.colors.white.Branco};
        background-color: ${theme.colors.green.Verde_AgroReceita};
      }
      
    svg{
      width: 36px;
      height: auto;
    }

    svg > g > g > path {
      fill: ${props => props.active === true ? theme.colors.green.Verde_AgroReceita : theme.colors.gray.Cinza_2} !important;
    }
  }
`;

export const Link = styled.a`
  width: 38px;
  height: 38px;

  display: flex;
  align-items: center;
  justify-content: center;

  /* border-radius: 16px;
  --link-bg: ${props => (props.active ? theme.colors.green.Verde_AgroReceita : theme.colors.white.Branco )};
  background-color: var(--link-bg); */

  >img{
    width: 24px;
    height: auto;
  }

  >svg > g > path {
    fill: ${props => props.active === true ? theme.colors.white.Branco : theme.colors.gray.Cinza_2} !important;
  }

  svg > g > g > path {
    fill: ${props => props.active === true ? theme.colors.green.Verde_AgroReceita : theme.colors.gray.Cinza_2} !important;
  }
`;
